import React, { FC } from 'react';
import './_styles.background.css';
import { motion } from 'framer-motion';

const variants = {
  hidden: {
    backdrop: 'blur(10px)',
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
    },
  },
  enter: {
    backdrop: 'blur(0px)',
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
  exit: {
    backdrop: 'blur(10px)',
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
    },
  },
};

interface BackgroundProps {
  image: string;
  format?: 'png' | 'jpg' | 'svg' | 'jpeg';
  children: React.ReactNode;
}

const Background: FC<BackgroundProps> = ({
  children,
  image,
  format = 'png',
}) => {
  return (
    <motion.div
      layout
      style={{ backgroundImage: `url('/backgrounds/${image}.${format}')` }}
      className='screen-background'
      transition={{ duration: 0 }}
    >
      <motion.div
        variants={variants}
        initial='hidden'
        animate='enter'
        exit='exit'
        className='absolute left-0 top-0 w-screen h-screen z-0'
      />
      {children}
    </motion.div>
  );
};

export default Background;
